import React from "react";
import { Container } from "react-bootstrap";
const AuthFooter = () => {
    return (
        <React.Fragment>
            <footer className="bg-light border-top py-1 fixed-bottom">
                <Container fluid>
                    &copy; Instalasi SIMRS RSABHK - 2023
                </Container>
            </footer>
        </React.Fragment>
    );
}
export default AuthFooter;